var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5082 0.0620917C31.5023 3.22887 2.1538 33.2675 0 70.6102L16.1709 61.2595C21.1805 39.6912 37.7119 22.5522 58.9155 16.7031L68.5082 0.0620917Z",
    fill: "#D90429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.917 61.7499C128.979 39.6559 111.972 22.1271 90.1896 16.4699L80.6955 0C118.21 2.8229 148.039 33.2438 150 71.05L133.917 61.7499Z",
    fill: "#EF233C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6912 133.432C110.615 128.073 126.47 112.761 132.615 93.1448L149.653 83.2924C145.76 118.932 117.012 147.087 81.1407 150L90.6912 133.432Z",
    fill: "#2B2D42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.527 93.6667C23.6954 112.745 39.0724 127.672 58.4082 133.189L68.0602 149.933C32.7027 146.695 4.43139 118.915 0.373612 83.7478L17.527 93.6667Z",
    fill: "#8D99AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.226 49.4167L110.25 101.784H101.215L91.061 61.4611L80.9065 101.784H71.872L60.8962 49.4167H70.976L77.1732 86.5224L86.5064 49.4167H95.6156L104.949 86.3727L111.146 49.4167H121.226Z",
    fill: "#EDF2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 101.715C39.3353 101.715 36.8838 101.297 34.5304 100.462C32.226 99.5784 30.2893 98.3999 28.7203 96.9267L32.3976 90.5184C33.6233 91.6478 35.0207 92.5563 36.5896 93.2437C38.2076 93.8821 39.8256 94.2013 41.4436 94.2013C43.9931 94.2013 45.8317 93.3419 46.9594 91.6232C48.0871 89.9045 48.651 87.1055 48.651 83.2261V57.5307H32.3976L36.5896 49.4167H57.9176V84.4783C57.9176 90.3219 56.6183 94.6678 54.0197 97.516C51.4211 100.315 47.3762 101.715 41.8848 101.715Z",
    fill: "#EDF2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinal);
export default __webpack_public_path__ + "static/media/LogoFinal.688734e891a6bfa80eb51507bf16eeee.svg";
export { ForwardRef as ReactComponent };